
import React, { Component } from 'react';
import PhoneNumberSelection from './PhoneNumberSelection/PhoneNumberSelection';
import VerificationStep from './VerificationStep/VerificationStep';
import SuccessMessage from './SuccessMessage/SuccessMessage';
import MfaModal from '../Modal/MfaModal';
import {handleSendCodeHelper, handleVerifyHelper, getVerifyErrMsg, handleCancelHelper, isNoExist} from './TurnOnMFAContainerHelper';
import { getLocalizedStrings } from  '../mfaPageLocalizedStrings';
class TurnOnMFAContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {phoneNumbers: [], encryptedselectedPhoneNumber: '', newPhoneNumber: {}, verificationCode: '', currentScreen: 'select',  receiveCodeVia: 'text', showLoader: true, showError: false, noPhoneNumberPresent: false, isSamePhone: false, verifyErrMsg: '', verifyErrorCode: ''};
    this.strings = getLocalizedStrings('TurnOnMFA');
  }

  componentDidMount() {
    this.fetchPhoneNumbers();
    const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo')) || {};
    this.setState({ userLoginInfoDetails });
  }

  componentDidUpdate() {
    const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo')) || {};
    if (this.props.rateChange && !app.appService.isAuthenticated()){
      const languagePrefRes = app.appService.getSessionstorage('customerPreferenceData') || {};
      if(languagePrefRes.emailAddresses){
        const primaryEmail = languagePrefRes.emailAddresses.filter((data) => data.standardIndicatorEmail === 'X');
        if(primaryEmail){
        userLoginInfoDetails.emailId = primaryEmail[0].email;
      }
      }
    }
    if (JSON.stringify(userLoginInfoDetails) !== JSON.stringify(this.state.userLoginInfoDetails)) {
      this.setState({
        userLoginInfoDetails,
      });
    }
  }
    fetchPhoneNumbers = async () => {
      const { fromProfile, fromPayment } = this.props;
      if (fromProfile || fromPayment) {
        const languagePrefRes = app.appService.getSessionstorage('customerPreferenceData') || {};
        const languagePrefResPhones = languagePrefRes.phoneNumbers || [];
        const noPhoneNumberPresent = languagePrefResPhones.length === 0 ? true : false;
        const phoneNumbers = languagePrefResPhones.map((el) => {
          return { 'maskedNumber': el.maskedNumber, 'encryptedNumber': el.encryptedvalue };
        });
        this.setState({ phoneNumbers, noPhoneNumberPresent, showError: false, showLoader: false, businessPartnerNumber: languagePrefRes.businessPartnerNumber || '' });
        return;
      }
      this.setState({ showLoader: true });
      const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo')) || {};
      const { ldapId = '' } = userLoginInfoDetails;
      try {
        const phoneObj = {
          ldapId
        };
        const {bpNumber, results:bpArr=[]} = await app.centralizedService.getPhoneNoList(phoneObj);
        const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
        const phoneNumbers = bpArr.map((el) => {
          if (!app.appService.isAuthenticated()) {
            preLoginEncryptPhone.push(el.encryptedvalue);
          }
          return { 'maskedNumber': el.maskedNumber, 'encryptedNumber': el.encryptedvalue };
        });
        app.appService.setSessionstorage('preLoginPhone', preLoginEncryptPhone);

        let businessPartnerNumber = '';
        if (bpArr.length > 0) {
          businessPartnerNumber = bpArr[0].businessPartnerNumber;
        }else{
          businessPartnerNumber = bpNumber;
        }
        this.setState({ phoneNumbers, businessPartnerNumber, showLoader: false, showError: false });
      } catch (error) {
        this.setState({ showError: true, showLoader: false });
      }
    };

    handleReSubmit = () => {
      this.fetchPhoneNumbers();
    }

    handleCancel = () => {
      handleCancelHelper.call(this);
    };

    handleAddPhoneNumber = (event) => {
      let name = '';
      const value = event.target.value ? event.target.value.match(/\d+/g).join('') : event.target.value;
      if (value.length > 6) {
        name = `(${value.slice(0, 3)})${value.slice(3, 6)}-${value.slice(6)}`;
      } else if (value.length > 3) {
        name = `(${value.slice(0, 3)})${value.slice(3)}`;
      } else {
        name = value; }
      const phoneNumber = {
        name,
        value,
      };
      this.setState({ newPhoneNumber: phoneNumber, sendCodeResponseObj: {}, isSamePhone: false });
    }

    handlePhoneEncryption = () => {
      const { selectedPhoneNumber, newPhoneNumber, encryptedselectedPhoneNumber } = this.state;
      if (selectedPhoneNumber === 'add-new' && newPhoneNumber.value && newPhoneNumber.value !== '') {
        let reqObj = { phoneNo: this.state.newPhoneNumber.value };
        app.myAccountService.baPhoneEncryption(reqObj).then((response) => {
          if(isNoExist.call(this,response.phoneNumber)){
            this.setState({ isSamePhone: true });
            return;}
          if(!app.appService.isAuthenticated()){
            const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
            preLoginEncryptPhone.push(response.phoneNumber);
            app.appService.setSessionstorage('preLoginPhone', preLoginEncryptPhone);
          }
          this.setState({ newEncryptedPhone: response.phoneNumber });
          this.handleSendCode(response.phoneNumber);
        }, () => { /* This is intentional */ });
      } else {
        this.handleSendCode(encryptedselectedPhoneNumber);
      }
    }

    handleSendEmailCode = () => {
      this.setState({ receiveCodeVia: 'email' }, () => this.handlePhoneEncryption());
    }

    handleSendCode = async (phoneNo) => {
      handleSendCodeHelper(this,phoneNo);
    };

    handleReceiveCodeVia = (event) => {
      this.setState({ receiveCodeVia: event.target.value });
    };

    onEnterKeyPress = (event,func) => {
      if(event.key === 'Enter'){
        func();
      }
    };

  handleVerify = async () => {
    // make a call to verification endpoint
    const { rateChange } = this.props;
    const { verificationCode } = this.state;
    this.setState({ showLoader: true });
    if (verificationCode === '') {
      this.setState({ showLoader:false, showError: true, verifyErrMsg: 'Please enter a valid verification code' });
      return;
    }
    if (rateChange && !app.appService.isAuthenticated() && location.pathname.includes("business")) {
      handleVerifyHelper(this);
    } else {
      this.handleVerifySecondHelper();
    }
  };

  isFactor = (factors) => {
    return factors ? true : false;
  };

  handleVerifySecondHelper = async () => {
    const { fromPayment, rateChange, factors, onHandleRateSubmit = (() => { /* This is intentional */ }), disableTwoFaPopup = (() => { /* This is intentional */ }), rateChangeEvent } = this.props;
    const { userLoginInfoDetails, receiveCodeVia, sendCodeResponseObj = {}, verificationCode, encryptedselectedPhoneNumber, newEncryptedPhone, businessPartnerNumber, selectedPhoneNumber, newPhoneNumber, phoneNumbers } = this.state;
    try {
      const twoFactorAuthValues = {
        type: receiveCodeVia,
        oktaId: userLoginInfoDetails.oktaUid,
        encValue: newEncryptedPhone || encryptedselectedPhoneNumber,
        value: userLoginInfoDetails.emailId,
        mainBpNumber: businessPartnerNumber || '',
        factors: this.isFactor(factors)
      };
      let newMfaAttributes = null;
      if (!fromPayment) {
        newMfaAttributes = {
          oktaUpdate: 1,
          addUpdate: {
            profileUpdate: [
              {
                'elementName': 'primaryPhone',
                'elementValue': twoFactorAuthValues.encValue
              },
              {
                'elementName': 'eixSCEMFAStatus',
                'elementValue': 'Enrolled'
              },
            ]
          }

        };
      }

      if (newEncryptedPhone && !fromPayment) {
        newMfaAttributes['addUpdate']['phoneNumbers'] = [{
          'standardIndicatorPhoneNumber': '',
          'telephoneNumber': newEncryptedPhone,
          'changeFlag': 'I',
          'telephoneExtension': '',
          'indicatorSmsEnabled': '',
          'indicatorTelephone': '3',
          'flagNotUsed': '',
          'sequenceNumber': ''
        }];
      }
      const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
      if (app.appService.isAuthenticated() && preLoginEncryptPhone.includes(twoFactorAuthValues.encValue)) {
        twoFactorAuthValues['txnName'] = 'mfa';
      }
      const res = await app.centralizedService.verifyPin(twoFactorAuthValues, verificationCode, 'Mobile', sendCodeResponseObj, newMfaAttributes, true);
      if (res.factorstatus === 'Success') {
        app.appService.removeSessionStorageItem('invalidOtpCounter');
        if (rateChange) {
          disableTwoFaPopup();
          rateChangeEvent && onHandleRateSubmit(rateChangeEvent);
          return;
        }
        if (fromPayment) {
          app.appService.setSessionstorage('isTwoFaPassed', true);
          window.location.reload();
          return;
        }
        // setting number for profile settings page.
        let optedNumber = '';
        let optedNumberEncValue = '';
        if (selectedPhoneNumber === 'add-new' && newPhoneNumber.value && newPhoneNumber.value !== '') {
          optedNumber = newPhoneNumber.value;
          optedNumberEncValue = newEncryptedPhone;
        } else {
          optedNumberEncValue = encryptedselectedPhoneNumber;
          const optedNumberObj = phoneNumbers.find((el) => el.encryptedNumber === optedNumberEncValue) || {};
          optedNumber = optedNumberObj.maskedNumber || '';
        }
        optedNumber = optedNumber.slice(0, -4).replace(/\d/g, 'X') + optedNumber.slice(-4);
        app.appService.setLocalStorage('mfaInfo', {
          ...userLoginInfoDetails,
          eixSCEMFAStatus: 'Enrolled',
          maskedValue: optedNumber, phoneNumber: optedNumberEncValue
        });
        this.setState({ currentScreen: 'success', showLoader: false, showError: false });
      } else {
        throw {Message:'Verification failed', response: res};
      }
    } catch (error) {
      const {verifyErrMsg, errorCode} = getVerifyErrMsg(error.response);
      this.setState({ showLoader: false, showError: true, verifyErrMsg, verifyErrorCode:errorCode });
    }
  };

    handleGoToAccount = (profileClicked) => {
      const { onClose = (() => { /* This is intentional */ }), fromProfile, fromPayment, disableTwoFaPopup = (() => { /* This is intentional */ }),rateChange } = this.props;
      if (rateChange) {
        disableTwoFaPopup();
        return;
      }
      if (fromPayment) {
        history.back();
        return;
      }
      if (fromProfile) {
        onClose();
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().SELFSERVICESFORMS.PROFILE_PAGE);
        return;
      }
      if (profileClicked) {
        app.appService.setSessionstorage('profile', true);
        app.appService.customPostLoginNavigation(app.appUtil.getAppRoutes().BILLING.SETTINGS_PROFILE);}
      if (profileClicked === undefined && window.location.pathname === '/residential/rates/rate-plan-comparison-tool') {
        app.appService.setLocalStorage('userpath', app.appUtil.getAppRoutes().RATEANALYZER.RATE_LOADING_RESIDENTIAL);
        app.appService.setLocalStorage('isPortalUserAuthenticated', true);
        app.appService.setSessionstorage('RateAnalyzerLoggedInStatus', true);
      }
      const {isSpocUser} = app.appService.getSessionstorage('nonMigratedData') || {};
      if(isSpocUser){
        app.appUtil.navigateToFromLogin(app.appUtil.getAppRoutes().LOGIN.CHANGE_PASSWORD);
        return;
      }
      
      const data = app.appService.getSessionstorage('activateReqObj');
      this.setState({ showLoader: true });
      app.identityService.sessionService.setUpSessionInfo({...data, userOpted: 'Enrolled'}, true);
      app.appService.removeSessionStorageItem(app.appService.appConstants.isPwdChanged);
    };
    render() {
      const {phoneNumbers,selectedPhoneNumber,newPhoneNumber,verificationCode,currentScreen,showError,showLoader,receiveCodeVia,userLoginInfoDetails,noPhoneNumberPresent,verifyErrorCode,isSamePhone} = this.state;
      const { fromProfile, fromPayment } = this.props;
      return (<MfaModal isOpen>
        {currentScreen === 'select' && (
          <PhoneNumberSelection
            phoneNumbers={phoneNumbers} selectedPhoneNumber={selectedPhoneNumber} newPhoneNumber={newPhoneNumber}
            handleSelectPhoneNumber={(value, encrypted) => this.setState({ selectedPhoneNumber: value, encryptedselectedPhoneNumber: encrypted, newPhoneNumber: {}, sendCodeResponseObj: {} })}
            handleAddPhoneNumber={(e) => this.handleAddPhoneNumber(e)}
            handleCancel={this.handleCancel} handleReceiveCodeVia={this.handleReceiveCodeVia}
            handlePhoneEncryption={this.handlePhoneEncryption} handleSendCode={this.handleSendCode}
            showError={showError} showLoader={showLoader} receiveCodeVia={receiveCodeVia}
            fetchPhoneNumbers={this.fetchPhoneNumbers} isSamePhone={isSamePhone}
            fromPayment={fromPayment} rateChange={this.props.rateChange} handleViaEmail={this.handleSendEmailCode} noPhoneNumberPresent={noPhoneNumberPresent} onEnterKeyPress={this.onEnterKeyPress}
          />
        )}
        {currentScreen === 'verify' && (
          <VerificationStep
            phoneNumber={newPhoneNumber.value || selectedPhoneNumber} verificatonCode={verificationCode} 
            handleVerificatonCodeChange={(e) => {
              const value = e.target.value !== '' ? e.target.value.match(/\d+/g).join('') : '';
              this.setState({ verificationCode: value, showError: false });
            }}
            handleCancel={this.handleCancel} handleVerifyCode={this.handleVerify} verifyErrorCode={verifyErrorCode}
            handleMethodChange={() =>{
              if(this.state.verifyErrorCode === 'OKTA_E0000069' || this.state.verifyErrorCode === 'OKTA_E0000047'){
                return;
              } 
              this.setState({ currentScreen: 'select', encryptedselectedPhoneNumber: '', newPhoneNumber: {}, selectedPhoneNumber: null, newEncryptedPhone: '', sendCodeResponseObj: {}, receiveCodeVia: 'text', showError: false, verifyErrorCode: ''});
            }} handleResend={this.handlePhoneEncryption} showError={showError} showLoader={showLoader}  userLoginInfoDetails={userLoginInfoDetails}  receiveCodeVia={receiveCodeVia} fromPayment={fromPayment} noPhoneNumberPresent={noPhoneNumberPresent} onEnterKeyPress={this.onEnterKeyPress} verifyErrMsg={this.state.verifyErrMsg}
          />
        )}
        {currentScreen === 'success' && (<SuccessMessage phoneNumber={newPhoneNumber.value || selectedPhoneNumber} handleGoToAccount={this.handleGoToAccount} fromProfile={fromProfile} fromPayment={fromPayment} onEnterKeyPress={this.onEnterKeyPress} turnOn showLoader={showLoader} />)}
      </MfaModal>);
    }
}
export default TurnOnMFAContainer;
